import { gql } from '@apollo/client';

export const ENGINE_ATTRIBUTE_SAVED = gql`
  subscription engineAttributeUpdated {
    engineAttributeUpdated {
      engineAttributeId
    }
  }
`;

export const TEST_ENGINE_ATTRIBUTE_COMPLETED = gql`
  subscription testEngineAttributeCompleted {
    testEngineAttributeCompleted {
      scoringGridTestResult
    }
  }
`;

export const TEST_ENGINE_ATTRIBUTE_FAILED = gql`
  subscription testEngineAttributeFailed {
    testEngineAttributeFailed {
      engineAttributeId
      errorMessage
    }
  }
`;

export const ENGINE_ATTRIBUTE_DELETED = gql`
  subscription engineAttributeDeleted {
    engineAttributeDeleted {
      engineAttributeId
    }
  }
`;
